import Api from '../../api/Api'

const transaksi = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    transaksi_berjalan: [],
  },

  //mutations
  mutations: {
    SET_TRANSAKSI_BERJALAN(state, transaksi_berjalan) {
      state.transaksi_berjalan = transaksi_berjalan
    },
  },

  //actions
  actions: {
    create({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('transaksi/new_transaksi', param)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    checkoutwebinar({}, param) {
      return new Promise((resolve, reject) => {
        Api.post('checkout-webinar', param)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    checkoutworkshop({}, param) {
      return new Promise((resolve, reject) => {
        Api.post('checkout-workshop', param)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    create_workshop({ commit }, param) {
      return new Promise((resolve, reject) => {
        // Api.post('transaksi/workshop_new_transaksi', param)
        Api.post('transaksi/new-invoice', param)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    beli_paket({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('transaksi/beli_paket', param)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    cancelOrder({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('transaksi/cancelOrder', param)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    save_info_transaksi({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('info_transaksi', param)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    handlePayment({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(`detailPayment?id_transaksi=${param.id_transaksi}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    add_enrolled({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('transaksi/enroll_user', param)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    add_enrolled_workshop({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('transaksi/enroll_user_workshop', param)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    transaksi_berjalan({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `transaksi/listtransaksi?page=${data.page}&per_page=${data.per_page}&search=${data.search}&status=${data.status}&jenis=${data.jenis}&is_selesai=${data.is_selesai}&start=${data.start}&end=${data.end}`,
        )
          .then((response) => {
            commit('SET_TRANSAKSI_BERJALAN', response.data.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    transaksi_selesai({ commit }, filter) {
      return new Promise((resolve, reject) => {
        Api.get(
          `transaksi/transaksiselesai?status=${filter.status}&page=${filter.halaman}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    invoice({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `transaksi/invoice/${data.id}?id_transaksi=${data.id_transaksi}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {
    getTransaksiBerjalan(state) {
      return state.transaksi_berjalan
    },
  },
}

export default transaksi
